import React, { useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import MarketingService from './Marketservice';
import Increase from './Increase';
import Services from './Services';
import Yearexperience from './Yearexperience';
import Latestprojects from '../componant/Latestprojects';
import Finished from './Finished';
import Workprocess from './Workprocess';
// import Team from './Team';
import Happyclints from './Happyclints';
import Consultation from './Consultation';
import Newarticles from './Newsarticles';
import Makeslides from '../componant/Makeslides';
import Counsling from '../componant/Counsling';
import College2000 from '../componant/College2000';
import Dataa from '../componant/Dataa';
import Banner from '../componant/Banner';
import Footer from './Footer';

const Homepage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Grid sx={{ overflowX: 'hidden', overflowY: 'hidden' }}>
      <MarketingService />
      <Increase />
      <Services />
      <Yearexperience />
      <Latestprojects />
      <Finished />
      <Workprocess />
      {/* <Team /> */}
      <Happyclints />
      <Consultation />
      <Newarticles />
      {/* <Counsling/>
      <Makeslides/>
      <Dataa/>
      <College2000/>
      <Banner/> */}
      <Footer />
    </Grid>
  );
};

export default Homepage;
